import React from 'react';
import Panel from '../../../../styled/Panel';
import Slice from '../../../../components-legacy/Slice';
import useALPInformation from './useALPInformation';

interface IAlpInformationPanel {
  onClose: () => void;
}

const excludeSliceTypes = ['quickLinks'];

export default function AlpInformationPanel({ onClose }: IAlpInformationPanel) {
  const { data } = useALPInformation();

  if (!data) {
    return null;
  }
  return (
    <Panel onClose={onClose} className="no-body-padding">
      {data &&
        data.slices
          ?.filter((slice) => excludeSliceTypes.indexOf(slice.sliceType) === -1)
          .map((slice, order) => (
            <Slice key={`${slice.sliceType}__${order}`} order={order} {...slice} inPanel />
          ))}
    </Panel>
  );
}
